const CHANNEL_TYPES = Object.freeze({
  AMIO_CHAT: 'amio_chat',
  FACEBOOK_MESSENGER: 'facebook_messenger',
  TELEGRAM: 'telegram',
  WHATSAPP: 'whatsapp',
  EMAIL_DAKTELA: 'email_daktela'
})

const CHANNEL_TYPE_ICON_MAP = Object.freeze({
  amio_chat: 'AmioChatIconColored',
  facebook_messenger: 'MessengerIconColored',
  telegram: 'TelegramIconColored',
  whatsapp: 'WhatsappIconColored',
  email_daktela: 'DaktelaIconColored'
})

export { CHANNEL_TYPES, CHANNEL_TYPE_ICON_MAP }
